<script setup>
import { computed } from 'vue'
import { EyeOff, ArrowUp, ArrowDown } from 'lucide-vue-next'
import Button from '@/components/ui/button/Button.vue'
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from '@/components/ui/dropdown-menu'

const props = defineProps({
    title: {
        type: String,
        required: true,
    },
    column: {
        type: Object,
        required: true,
    },
})

const canHide = computed(() => {
    return typeof props.column.getCanHide !== 'function' || props.column.getCanHide()
})

const sortDirection = computed(() => props.column.getIsSorted())
</script>
<template>
    <div class="flex items-center space-x-2">
        <DropdownMenu>
            <DropdownMenuTrigger as-child>
                <Button
                    variant="ghost"
                    size="sm"
                    class="group text-semibold h-8 text-left text-xs uppercase data-[state=open]:bg-accent"
                >
                    <span>{{ props.title }}</span>
                    <div v-if="props.column.getCanSort()" class="my-auto ml-2 flex flex-col">
                        <AppIcon
                            name="chevron-up"
                            class="-mb-1 h-2.5 w-2.5 opacity-25"
                            :class="{
                                'text-indigo-600 !opacity-100': sortDirection === 'asc',
                                'group-hover:text-indigo-600 group-hover:!opacity-100': sortDirection === 'desc',
                            }"
                        />
                        <AppIcon
                            name="chevron-down"
                            class="h-2.5 w-2.5 opacity-25 group-hover:text-slate-600 group-hover:!opacity-100"
                            :class="{
                                'text-indigo-600 !opacity-100': sortDirection === 'desc',
                            }"
                        />
                    </div>
                </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="start">
                <DropdownMenuItem v-if="props.column.getCanSort()" @click="props.column.toggleSorting(false)">
                    <ArrowUp class="mr-2 h-3.5 w-3.5 text-muted-foreground/70" />
                    Asc
                </DropdownMenuItem>
                <DropdownMenuItem v-if="props.column.getCanSort()" @click="props.column.toggleSorting(true)">
                    <ArrowDown class="mr-2 h-3.5 w-3.5 text-muted-foreground/70" />
                    Desc
                </DropdownMenuItem>
                <DropdownMenuItem v-if="canHide" @click="props.column.toggleVisibility()">
                    <EyeOff class="mr-2 h-3.5 w-3.5 text-muted-foreground/70" />
                    {{ column.getIsVisible() ? 'Hide' : 'Show' }}
                </DropdownMenuItem>
            </DropdownMenuContent>
        </DropdownMenu>
    </div>
</template>
